import axios from "@utils/axios-instance";
import { TEmailSignature, TUpdatePassword, TUpdateProfile, TUser } from "@/models/user.model";
import { TMyCallCenterPreferences } from "@/models/call.center.model";

export const getMe = async (): Promise<TUser> => {
  const response = await axios.get("/me");
  return response.data;
};

export const updateProfile = async (data: Omit<TUpdateProfile, "email">): Promise<void> => {
  // todo: find onw way to update the email in one go
  await axios.patch("/me/profile", data);
};

const updateMyCallCenterPreferences = async (data: Partial<TMyCallCenterPreferences>): Promise<void> => {
  const somethingToUpdate = Object.keys(data).length > 0;
  if (!somethingToUpdate) return;
  await axios.put("/me/callcenter/preferences", data);
};


export const updatePassword = async (data: TUpdatePassword): Promise<void> => {
  await axios.patch("/me/password", data);
};

export const updateEmailSignature = async (
  data: { html: string; enabled: boolean; includeLogo: boolean }
): Promise<TEmailSignature> => {
  const response = await axios.put("/me/email-signature", data);
  return response.data;
};

export default {
  getMe,
  updateEmailSignature,
  updateProfile,
  updateMyCallCenterPreferences
};
